export const GAIA_OPTIMIZELY_SNIPPET_SRC = 'https://cdn.optimizely.com/js/9102710358.js';

export const SECONDS_IN_MINUTE = 60;

export const TRIAL_DAYS = 7;

export const MONTHS_IN_YEAR = 12;
